import { Fragment } from 'react';
import styles from '../kyc-intelligence.module.css';

function CINResults({details}) {

    return (<>
        <div className={styles['basic-report-box']}>
            <h2>CIN results</h2>
            {details?.map((item, index) => {
                const companyDetails = item?.companyDetails?.result?.data;
                const directorDetails = item?.directorDetails;

                return (
                    <Fragment key={index}>
                        <h3>Result {index+1} - {item?.cin}</h3>
                        <h4>Company details</h4>
                        {companyDetails?.map((companyItem, companyIndex) => (
                            <Fragment key={companyIndex}>
                                <h5>Result {companyIndex+1}</h5>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>DIN: </span>
                                        {companyItem?.DIN || '-'}
                                    </div>
                                    <div>
                                        <span>CIN: </span>
                                        {companyItem?.CIN || '-'}
                                    </div>
                                    <div>
                                        <span>Name: </span>
                                        {companyItem?.NAME || '-'}
                                    </div>
                                    <div>
                                        <span>Designation: </span>
                                        {companyItem?.DESIGNATION || '-'}
                                    </div>
                                    <div>
                                        <span>Join date: </span>
                                        {companyItem?.DATE_JOIN || '-'}
                                    </div>
                                    <div>
                                        <span>Resign date: </span>
                                        {companyItem?.DATE_RESIGN || '-'}
                                    </div>
                                    <div>
                                        <span>Gender: </span>
                                        {companyItem?.gender || '-'}
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                        <h4>Director details</h4>
                        {directorDetails?.map((companyItem, companyIndex) => {
                            const creditScoreDetails = companyItem?.creditScoreDetail?.result;
                            const dinDetails = companyItem?.dinDetails;

                            return (
                                <Fragment key={companyIndex}>
                                    <h5>Result {companyIndex+1}</h5>
                                    <div className={styles['basic-report-details']}>
                                        <div>
                                            <span>Name: </span>
                                            {creditScoreDetails?.name || '-'}
                                        </div>
                                        <div>
                                            <span>PAN: </span>
                                            {creditScoreDetails?.pan || '-'}
                                        </div>
                                        <div>
                                            <span>Mobile: </span>
                                            {creditScoreDetails?.mobile || '-'}
                                        </div>
                                        <div>
                                            <span>Credit score: </span>
                                            {creditScoreDetails?.credit_score || '-'}
                                        </div>
                                    </div>
                                    <div style={{ paddingLeft: '50px' }}>
                                        <h4>DIN details</h4>
                                        {dinDetails?.map((dinItem, dinIndex) => (
                                            <Fragment key={dinIndex}>
                                                <h5>Result {dinIndex+1}</h5>
                                                <div className={styles['basic-report-details']}>
                                                    <div>
                                                        <span>DIN: </span>
                                                        {dinItem.DIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>CIN: </span>
                                                        {dinItem.CIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Joining date: </span>
                                                        {dinItem.DATE_JOIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Resignation date: </span>
                                                        {dinItem.DATE_RESIGN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Designation: </span>
                                                        {dinItem.DESIGNATION || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Address: </span>
                                                        {dinItem.ADDRESS || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Monetary contribution value: </span>
                                                        {dinItem.monetaryContributionValue || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Contribution form: </span>
                                                        {dinItem.contributionForm || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body corporate type: </span>
                                                        {dinItem.bodyCorporateType || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Profit sharing percentage: </span>
                                                        {dinItem.profitSharingPercentage || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body corp inside India name: </span>
                                                        {dinItem.bodyCorpInsideIndiaName || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body corp outside India name: </span>
                                                        {dinItem.bodyCorpOutsideIndiaName || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Approver CIN: </span>
                                                        {dinItem.APPROVER_CIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Company Name: </span>
                                                        {dinItem.COMPANY_NAME || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Company status: </span>
                                                        {dinItem.COMPANY_STATUS || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Paidup capital: </span>
                                                        {dinItem.PAIDUP_CAPITAL || '-'}
                                                    </div>
                                                </div>
                                            </Fragment>
                                        ))}
                                    </div>
                                </Fragment>
                            )
                        })}
                    </Fragment>
                )
            })}
        </div>
    </>);
}

export default CINResults;